// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ovX6mh4lX5IbrAxAE6Na{flex-direction:column;flex-grow:1;margin-top:32px;padding:0 12px;display:flex}.f9__7JYRawQw3m0dTvaK{align-items:center;gap:12px;padding:10px 0 10px 4px;display:flex}.JZnu4Ed7bYP236CEBhyx{flex-direction:column;gap:4px;min-width:0;display:flex}.dFqxHG_8tM8GWXrUAcdZ{background:var(--black-10);border:none;border-radius:6px}.L8raNzrDLeMUZDw8S2Il{line-height:16px}.s_CqPqGGsB4gvp962gNO{background:var(--black-10);border-radius:6px;padding:4px 8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `ovX6mh4lX5IbrAxAE6Na`,
	"name": `f9__7JYRawQw3m0dTvaK`,
	"nameInfo": `JZnu4Ed7bYP236CEBhyx`,
	"iconBox": `dFqxHG_8tM8GWXrUAcdZ`,
	"fieldType": `L8raNzrDLeMUZDw8S2Il`,
	"defaultLabel": `s_CqPqGGsB4gvp962gNO`
};
export default ___CSS_LOADER_EXPORT___;
